import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import ButtonViewGlossary from '../button-view-glossary/index';
import sectionDividerOptions from '../../../helpers/statics/section-divider-options';
import styles from './section-divider.module.scss';
import useProfileAppContext from '../../../stores/profile/use-profile-app-context';
import { augmentClassName } from '../../../utils/GlobalCssProxy';
import DynamicGreeting from '../../molecules/profile/dynamic-greeting';
const className = augmentClassName(styles);

// eslint-disable-next-line prefer-arrow-callback
const SectionDivider = React.memo(function SectionDivider({
  children,
  labelText,
  id,
  isDynamicGreetingShown,
  dynamicGreetingParticipantHoldings,
  showGlossaryButton
}) {
  const { channel, pageOffsetsTop } = useProfileAppContext();
  const navTargetByChannel = {
    public: 'nav-target',
    mytiaa: 'nav-target', // TIAA-9728 changing this will mess up the anchor links for MyTIAA
    ifa: 'nav-target-ifa',
    microsites: 'nav-target-microsites'
  };

  const navTargetClass = navTargetByChannel[channel] || navTargetByChannel.public;

  const documentStyles = document.documentElement.style;
  useEffect(() => {
    /*Using this CSS variable, we can have the section divider anchor tags respond to the height of the TIAA header */
    documentStyles.setProperty('--tiaaHeaderOffset', `${pageOffsetsTop}px`);
  }, [pageOffsetsTop, documentStyles]);

  const analytics = {};
  switch (labelText) {
    case sectionDividerOptions.allocation.label:
      analytics.id = 'MC_Allocation';
      break;
    case sectionDividerOptions.characteristics.label:
      analytics.id = 'MC_Characteristics';
      break;
    case sectionDividerOptions.performance.label:
      analytics.id = 'MC_PerformanceRisk';
      break;
    case sectionDividerOptions.resources.label:
      analytics.id = 'MC_Resources';
      break;
    default:
  }

  return (
    <section
      data-analytics-id={analytics.id}
      data-analytics-section="subpage"
      id={id}
      {...className(`${navTargetClass}`, 'header-margin')}
    >
      {isDynamicGreetingShown && dynamicGreetingParticipantHoldings && (
        <DynamicGreeting participantHoldings={dynamicGreetingParticipantHoldings} />
      )}
      <div
        data-analytics-componenttype="multi-column-component"
        data-analytics-id={analytics.id}
        data-analytics-section="component"
        {...className('section-divider')}
      >
        <h1 {...className('justify-content-between', 'd-flex', 'd-print-none')}>
          <div {...className('font-family-agenda', 'font-weight-light', 'font-size-18')}>
            {labelText}
          </div>
          {showGlossaryButton && <ButtonViewGlossary {...className('question-mark')} solid />}
        </h1>
        {children}
      </div>
    </section>
  );
});

SectionDivider.defaultProps = {
  showGlossaryButton: true
};

SectionDivider.propTypes = {
  children: PropTypes.node,
  labelText: PropTypes.string,
  /**
   * For top-level navigation reference
   */
  id: PropTypes.string,
  onClickGlossary: PropTypes.func,
  /**
   * Boolean to control icon display, resource section doesn't need the icon
   */
  showGlossaryButton: PropTypes.bool,
  isDynamicGreetingShown: PropTypes.bool,
  dynamicGreetingParticipantHoldings: PropTypes.oneOfType([PropTypes.bool, PropTypes.object])
};

export default SectionDivider;
